import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, NewSelectList, NewInputList, NewInputListHandles, NewModal, MainContentPaddingTypes, NewSelect, NewSelectHandles, NewSelectListHandles } from "../..";
import { css, glyphs } from "../../../Styles";
import { ButtonTypes, ListStyle_Types } from "../../../Definitions";
import { useAppSelector } from "../../../Store";
import { Graph_QL } from "../../../Services";

// DATA
import { useAnimal } from "../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal";

// TODO
import useSelectOptions from "../../_Components/useSelectOptions";

interface AddAnimalModal_Props {
  isModalOpen: boolean
  closeModal: () => void,
}

export default function AddAnimalModal({isModalOpen, closeModal}:AddAnimalModal_Props) {
  const {t} = useTranslation()
  const {feedcurveOptions, groupOptions} = useSelectOptions()
  const [message, setMessage] = useState<string|null>(null)
  
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);

  const inputRef = useRef<NewInputListHandles>(null);
  const selectRef = useRef<NewSelectHandles>(null)
  const selectRefs = useRef<NewSelectListHandles>(null)
  
  const { createAnimals: createAnimal } = useAnimal(connection);
  const {locationOptions} = useSelectOptions();

  const handleCreate = () => {
    if (inputRef && inputRef.current && inputRef.current.refs.current) {
      const animalNumber = +inputRef.current.refs.current[0].value;
      const responderNumber = +inputRef.current.refs.current[1].value;
      const lifeNumber = +inputRef.current.refs.current[2].value;
      let location_id;
      // let condition;
      let feedCurve;
      let group;
      let type;

      if (selectRef && selectRef.current) {
        location_id = selectRef.current.value.id ? Number(selectRef.current.value.id) : undefined;
      }
      
      if (selectRefs && selectRefs.current && selectRefs.current.refs.current) {
        // condition = selectRef.current.refs.current[0]?.value.id
        feedCurve = selectRefs.current.refs.current[1]?.value.id
        group = selectRefs.current.refs.current[2]?.value.id
        type = selectRefs.current.refs.current[3]?.value.id
      }

      if (!animalNumber) {
        inputRef.current.refs.current[0].setError()
        setMessage(t("animalPages.animals.missingAnimalNo", {defaultValue: "animal no. is missing"}))
      } else if (!responderNumber) {
        inputRef.current.refs.current[1].setError()
        setMessage(t("animalPages.animals.missingResponderNo", {defaultValue: "responder no. is missing"}))
      } else {
        if (createAnimal) {
          createAnimal([{
            animal_number: animalNumber, 
            responder_number: responderNumber, 
            life_number: lifeNumber,
            location_id,
            // condition: condition,
            feedcurve_id: Number(feedCurve),
            animal_group_id: Number(group),
            animal_type: Number(type)
          }])
          closeModal()
        }
      }
      setTimeout(() => {
        setMessage(null);
      }, 2000);
    }
  }
      
  return (
    <NewModal
      modalState={isModalOpen}
      header={t("animalPages.animals.newAnimal", {defaultValue: "New Animal"})}
      predefinedButtons={{
        onClose: closeModal
      }}
      overrides={{
        mainContentPadding: MainContentPaddingTypes.secondary
      }}
      mainContent={
        // <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "40px"}}>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "start", justifyContent: "center", columnGap: "40px", rowGap: "10px"}}>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px"}}>
            <NewInputList
              ref={inputRef}
              startEnhancers={[glyphs.AnimalNumber({}), glyphs.ResponderNumber({}), glyphs.LifeNumber({})]}
              placeholders={[t("params.animalId", {defaultValue: "animal no."}), t("params.responderNo", {defaultValue: "responder no."}), t("params.lifeNo", {defaultValue: "life no."})]}
              isRequired={[true, true, false]}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px"
              }}
            />
            <NewSelect
              ref={selectRef}
              placeholder={t("params.location", {defaultValue: "location"})}
              startEnhancer={glyphs.Location({})}
              options={locationOptions ?? []}
            />
          </div>
          <NewSelectList
            ref={selectRefs}
            startEnhancers={[glyphs.Condition({}), glyphs.Animal({}), glyphs.AnimalGroup({}), glyphs.AnimalType({})]}
            placeholders={[t("params.condition", {defaultValue: "condition"}), t("params.feedCurve", {defaultValue: "feed curve"}), t("params.group", {defaultValue: "group"}), t("params.animalType", {defaultValue: "animal type"})]}
            options={[[], feedcurveOptions, groupOptions, []]}
            listOverrides={{
              listStyle: ListStyle_Types.vertical,
              listGap: "10px"
            }}
          />
        </div>
      // </div>
      }
      footerMessage={message ?? ""}
      footerContent={
        <Button 
          content={t("buttons.create", {defaultValue: "create"})}
          buttonType={ButtonTypes.primaryButton}
          overrides={{
            baseButton: {...css.button_FitContent}
          }}
          onClick={() => {handleCreate()}}
        />
      }
    />
  );
}